import React from "react";
import Carousel from "nuka-carousel";
import { useSelector } from "react-redux";

function Dashboardonestepsection() {
	const { coursesByHub } = useSelector(
		(state) => state.courseDetails
	);

	const coreHub = coursesByHub?.find(hub => hub?.hubName === "Foundation");
	const genAiHub = coursesByHub?.find(hub => hub?.hubName === "GenAI and Agentic AI Hub");

	const progressData = [
		{
			title: "Core Hub",
			value: coreHub?.completionPercentage,
			label: "Complete Core Hub to move closer to Gold badge",
		},
		{
			title: "GenAI Agentic Hub",
			value: genAiHub?.completionPercentage,
			label: "Complete GenAI Agentic Hub to unlock next level",
		},
		{
			title: "Delivery Modernisation Hub",
			value: 0,
			label: "Complete Delivery Modernisation Hub to unlock next level",
		},
		{
			title: "Digital Customer.Next",
			value: 0,
			label: "Complete Digital Customer.Next to earn Silver badge",
		},
		{
			title: "Future of Experience Hub",
			value: 0,
			label: "Complete Future of Experience Hub to earn Silver badge",
		},
		{
			title: "Sales & Solutioning Hub",
			value: 0,
			label: "Complete Sales & Solutioning Hub to earn Silver badge",
		},
		{
			title: "Product Hub",
			value: 0,
			label: "Complete Product Hub to earn Silver badge",
		},
	];

	return (
		<div className="dashboard-onestep-holder">
			<h3>You are one step away for the Silver Badge</h3>

			<Carousel
				autoplay={false}
				wrapAround={true}
				slidesToShow={1}
				withoutControls={false}
			>
				{progressData.map((item, index) => (
					<div className="progress-bar-box" key={index}>
						<div className="progress-container">
							<div className="progress-header">
								<span className="progress-value">{item.value}%</span>
								<span className="progress-value content">{item.title}</span>
							</div>

							<div className="progress-track">
								<div
									className="progress-fill"
									style={{ width: `${item.value}%` }}
								/>
							</div>
						</div>

						<span className="progress-label">{item.label}</span>
					</div>
				))}
			</Carousel>
		</div>
	);
}

export default Dashboardonestepsection;
